import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../../Context/GlobalContext";

const useGatewayLogin = () => {
  const { api } = useContext(GlobalContext);

  const [gatewayLoading, setGatewayLoading] = useState(false);

  const gatewayLoginApi = async ({ mobileNumber, otp, step }) => {
    try {
      setGatewayLoading(true);

      const payload = {
        mobileNumber: mobileNumber || "",
        otp: otp || "",
        step: step || "",
      };

      const response = await api.post("/api/Client/v1.0/GateWay", payload);

      return response.data;
    } catch (error) {
      console.error("Gateway Login Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong",
      );

      return null;
    } finally {
      setGatewayLoading(false);
    }
  };

  return {
    gatewayLoading,
    gatewayLoginApi,
  };
};

export default useGatewayLogin;
